export const environment = {
	production: true,
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	// api_url: 'https://app.kaspontech.com/chadmin-reports/'  ,           // Fieldpro live URL
 	// api_url: 'https://fieldpro.kaspontech.com/fpadmin/',	     // Fieldpro Dev URL
	// image_static_ip:"https://fieldpro.kaspontech.com/",
	// image_static_ip:"https://app.kaspontech.com/",
	api_url: 'https://cyrixapp.kaspontech.com/chadmin/',
	// api_url: 'https://cyrixapp.kaspontech.com/chadmin-qa/',
	// api_url: 'https://cyrixpvtapi.kaspontech.com/private-chadmin/',
	image_static_ip:"https://cyrixapp.kaspontech.com/",

};
